import React, { useState } from 'react';
import { Send, Sparkles } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Textarea } from '../components/ui/textarea';
import { Input } from '../components/ui/input';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '../components/ui/select';

const Playground = () => {
  const [prompt, setPrompt] = useState('');
  const [selectedModel, setSelectedModel] = useState('gpt4');
  const [output, setOutput] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleGenerate = () => {
    if (!prompt.trim()) return;
    
    setIsLoading(true);
    // Simulate AI response
    setTimeout(() => {
      setOutput(`This is a simulated response for your prompt: "${prompt}"

Using model: ${selectedModel}

In a real implementation, this would connect to an AI API and generate actual content based on your prompt. The response would be streamed here for you to copy and use in your projects.`);
      setIsLoading(false);
    }, 1500);
  };

  return (
    <div className="space-y-6">
      <div className="flex items-center gap-3">
        <div className="w-10 h-10 rounded-lg bg-gradient-to-br from-purple-600 to-pink-500 flex items-center justify-center">
          <Sparkles size={20} className="text-white" />
        </div>
        <div>
          <h1 className="text-3xl font-bold text-white">Play Ground</h1>
          <p className="text-gray-400">Test and experiment with AI prompts</p>
        </div>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        {/* Input Section */}
        <div className="space-y-4">
          <div className="bg-[#1a1a2e] rounded-xl p-4 border border-gray-800">
            <h2 className="text-white font-semibold mb-3">Your Prompt</h2>
            <Textarea
              placeholder="Enter your prompt here..."
              value={prompt}
              onChange={(e) => setPrompt(e.target.value)}
              className="min-h-[200px] bg-[#12121a] border-gray-700 text-white placeholder:text-gray-500 resize-none"
            />
          </div>

          <div className="bg-[#1a1a2e] rounded-xl p-4 border border-gray-800">
            <h2 className="text-white font-semibold mb-3">Settings</h2>
            <div className="space-y-3">
              <div>
                <label className="text-gray-400 text-sm mb-1 block">AI Model</label>
                <Select value={selectedModel} onValueChange={setSelectedModel}>
                  <SelectTrigger className="bg-[#12121a] border-gray-700 text-white">
                    <SelectValue />
                  </SelectTrigger>
                  <SelectContent className="bg-[#1a1a2e] border-gray-700">
                    <SelectItem value="gpt4" className="text-white hover:bg-purple-600/30">ChatGPT-4</SelectItem>
                    <SelectItem value="claude" className="text-white hover:bg-purple-600/30">Claude 3.5</SelectItem>
                    <SelectItem value="gemini" className="text-white hover:bg-purple-600/30">Gemini Pro</SelectItem>
                  </SelectContent>
                </Select>
              </div>
            </div>
          </div>

          <Button
            onClick={handleGenerate}
            disabled={!prompt.trim() || isLoading}
            className="w-full bg-purple-600 hover:bg-purple-700 text-white py-6"
          >
            {isLoading ? (
              <span className="flex items-center gap-2">
                <div className="w-4 h-4 border-2 border-white/30 border-t-white rounded-full animate-spin" />
                Generating...
              </span>
            ) : (
              <span className="flex items-center gap-2">
                <Send size={18} />
                Generate Response
              </span>
            )}
          </Button>
        </div>

        {/* Output Section */}
        <div className="bg-[#1a1a2e] rounded-xl p-4 border border-gray-800">
          <h2 className="text-white font-semibold mb-3">Output</h2>
          <div className="min-h-[350px] bg-[#12121a] rounded-lg p-4 border border-gray-700">
            {output ? (
              <p className="text-gray-300 whitespace-pre-wrap">{output}</p>
            ) : (
              <p className="text-gray-500">Your generated content will appear here...</p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Playground;
